// Static content to replace Contentful CMS
export const staticContent = {
    // Why Tacnique section content
    whyTacnique: {
        whyTacniqueHeader: "Why Tacnique",
        whyTacniqueDescription: "The most extensive part of the recruitment process is the time. Tacnique helps you solve such bottlenecks by accomplishing higher results in shorter periods of time."
    },

    // Why Tacnique list items (for the circular layout)
    whyTacniqueList: [
        {
            title: "Save Time",
            containerClass: "point deg0",
            innerContainerClass: "p-6 rounded-full flex items-center justify-start space-x-6 w-60 lg:w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
            imageLeft: false,
            icon: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/save-time.svg"
                    }
                }
            },
            testId: "why-save-time"
        },
        {
            title: "Reduce Cost",
            containerClass: "point deg60",
            innerContainerClass: "p-6 rounded-full flex items-center justify-start space-x-6 w-60 lg:w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
            imageLeft: true,
            icon: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/reduce-cost.svg"
                    }
                }
            },
            testId: "why-reduce-cost"
        },
        {
            title: "Quality Hire",
            containerClass: "point deg120",
            innerContainerClass: "p-6 rounded-full flex items-center justify-start space-x-6 w-60 lg:w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
            imageLeft: false,
            icon: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/quality-hire.svg"
                    }
                }
            },
            testId: "why-quality-hire"
        },
        {
            title: "Scale Teams",
            containerClass: "point deg180",
            innerContainerClass: "p-6 rounded-full flex items-center justify-start space-x-6 w-60 lg:w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
            imageLeft: true,
            icon: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/scale-teams.svg"
                    }
                }
            },
            testId: "why-scale-teams"
        },
        {
            title: "Data Driven",
            containerClass: "point deg240",
            innerContainerClass: "p-6 rounded-full flex items-center justify-start space-x-6 w-60 lg:w-72 h-12 shadow-[10px_0px_10px_0px_#6a6a6a40]",
            imageLeft: false,
            icon: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/data-driven.svg"
                    }
                }
            },
            testId: "why-data-driven"
        },
        {
            title: "Better Experience",
            containerClass: "point deg300",
            innerContainerClass: "p-6 rounded-full flex items-center justify-start space-x-6 w-60 lg:w-72 h-12 shadow-[-10px_0px_10px_0px_#6a6a6a40]",
            imageLeft: true,
            icon: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/better-experience.svg"
                    }
                }
            },
            testId: "why-better-experience"
        }
    ],

    // Client testimonials
    clientTestimonials: [
        {
            userName: "Krishna Pandya",
            userDesignation: "Associate People Manager",
            review: "We were really impressed with the recorded Interview and their detailed assessment which really helps us to make the hiring decision very fast. By scheduling Interviews with Tacnique, we are also saving our tech team valuable time.",
            desc: "",
            companyLogo: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/solutelabslogo.png"
                    }
                }
            },
            userPhoto: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/krishna.png"
                    }
                }
            }
        }
    ],

    // Candidate reviews
    candidateReviews: [
        {
            name: "Sumit S",
            ratings: "5",
            description: "The interview was challenging and interesting. It's highly engaging.",
            userImage: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/profile.svg"
                    }
                }
            }
        },
        {
            name: "Priyanka C",
            ratings: "5",
            description: "This was the first time that the interviewer made things so clear and explained everything. Thanks Tacnique.",
            userImage: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/profile.svg"
                    }
                }
            }
        },
        {
            name: "Ankita R",
            ratings: "4",
            description: "It was a great interview session. The process was easy and smooth.",
            userImage: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/profile.svg"
                    }
                }
            }
        },
        {
            name: "Arnab D",
            ratings: "5",
            description: "Really liked it and learnt a lot. Highly recommended.",
            userImage: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/profile.svg"
                    }
                }
            }
        },
        {
            name: "Seema S",
            ratings: "4",
            description: "Good experience to have such wonderful discussion and getting instant feedbacks.",
            userImage: {
                fields: {
                    file: {
                        url: "//images.ctfassets.net/placeholder/profile.svg"
                    }
                }
            }
        }
    ],

    // FAQs for candidates
    faqs: {
        candidate: [
            {
                title: "What are the primary parameters you use to evaluate a candidate?",
                description: "At Tacnique, we've developed a cutting-edge candidate evaluation process that leaves no stone unturned. Our comprehensive approach entails deep diving into key insights from our rigorous tech interview. We meticulously evaluate various factors such as behavioral competencies, knowledge competencies, and coding & problem-solving skills. Each section is further elaborated into 30+ insights to ensure you select only the best candidate for your team."
            },
            {
                title: "What is the interview process and format?",
                description: "The interview process is a carefully crafted and thought-out affair that aims to uncover the best talent in the tech industry. The format is split into three parts, each designed to test your skills and expertise in different areas. \n \n \n• The introduction section, which lasts for 5 minutes, allows you to showcase your personality and communication skills. This gives technical interviewers an insight into how well you can collaborate and work in a team. \n \n• The project discussion section, which lasts for 10 minutes, focuses on your ability to understand complex project requirements and develop innovative solutions. \n \n• The coding and problem-solving section, which lasts for 30 minutes, is where you will be asked to demonstrate your technical abilities. You will be given a series of coding challenges and problems to solve. \n \n• The wrap-up section lasts for 15 minutes, where you can ask any questions you may have and wrap up the interview. However, if you are an associate software engineer or junior QA engineer, the wrap-up will only last 5 minutes. \n \n"
            },
            {
                title: "Which are the top tech companies you partner with, and the positions are they currently hiring for?",
                description: "We work with an impressive array of renowned companies that span diverse industries, from real estate and finance to healthcare and technology. Some of our esteemed clients include VTS, Zamp Finance, Medikabazaar, Solutelabs, Visa, Medicine Patent Pool, Alhabtoor, Zillow, JLL, and many more. \n \n These companies seek talented software engineering and coding professionals for various positions requiring expertise in cutting-edge web technologies, such as Javascript, Python, Ruby, and more. Additionally, our clients seek individuals proficient in cloud technologies like AWS, GCP, Azure, and other industry-leading platforms."
            },
            {
                title: "Can I see the interviewer's profile?",
                description: "Our experienced technical interviewers conduct thorough and unbiased assessments of your skills. To ensure complete transparency, we offer access to the interviewer's profile, including their name, skills, number of interviews conducted, rating, and other relevant information. This information is accessible in the interview evaluation report, providing a comprehensive understanding of the interviewer's qualifications."
            }
        ]
    },

    // Blog content (empty for now, can be populated if needed)
    blog: {
        fields: {
            blog: null
        }
    }
};
